
/**
 * 추가 메타데이터
 */
export type MediaFileResponseMetadata = { [key: string]: unknown };
